import Handlebars from 'handlebars';

Handlebars.registerHelper('removePeriods', function (text) {
  text = Handlebars.Utils.escapeExpression(text);
  text = text.split('.').join('-');
  return new Handlebars.SafeString(text);
});
